import React, { useContext, useEffect, useState } from "react";
import { Row, Button, Container, Input, Tooltip } from "reactstrap";
import { Table } from "../../../../components/CustomPaginations";
import { Redirect, useHistory, Link } from "react-router-dom";
import axios from "axios";
import { UserConsumer, UserContext } from "../../../../UserContext";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { tableStyle } from "../../../../components/TableStyle";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import Edit from "../../../../images/edit.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Header from "../../../../components/Header";
import { AlertPopups } from "../../../../components/AlertPopups";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../../components/GlobalPaginationSize";
import { Routes } from "../../../../configurations/config";

const ItemRequisitionVendors = () => {
	let empDesignation = null;
	const defaultSorted = [
		{
			dataField: "name",
			order: "asc",
		},
	];
	const { token } = useContext(UserContext);
	const [vendor, setVendor] = useState([]);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const history = useHistory();

	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);
		getVendors();
	}, []);

	const getVendors = (searchKey = "") => {
		axios
			.get(
				`${
					ItemRequisitionAPI.GetItemRequisitionVendor
				}?PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}${searchKey ? "&SearchTerm=" + searchKey : ""}`,
				{ headers: { Authorization: `Bearer ${token} ` } }
			)
			.then((res) => {
				setPagerData(JSON.parse(res.headers["x-pagination"]));
				setVendor(res.data.vendors);
				setIsLoading(false);
			});
	};

	const getColumns = [
		{
			dataField: "name",
			text: "Name",
			sort: true,
			formatter: (cell, row) => {
				return (
					<abbr title={row.name}>
						{row.name?.length > 20
							? row.name.slice(0, 19) + "..."
							: row.name}
					</abbr>
				);
			},
		},
		{
			dataField: "primaryContact",
			text: "Primary Contact",
			sort: true,
		},
		{
			dataField: "phone",
			text: "Phone",
			sort: true,
		},
		{
			dataField: "email",
			text: "Email",
			sort: true,
			formatter: (cell, row) => {
				return (
					<abbr title={row.email}>
						{row.email?.length > 20
							? row.email.slice(0, 19) + "..."
							: row.email}
					</abbr>
				);
			},
		},
		{
			dataField: "editVendor",
			text: "Edit Vendor",
			formatter: (cell, row) => {
				return (
					<div style={{ textAlign: "center" }}>
						<Link to={`${Routes.CreateNewVendor}/${row.id}`}>
							<img
								style={{ height: "20px", width: "20px" }}
								src={Edit}
								alt="Edit"
								title="Modify Vendor"
							/>
						</Link>
					</div>
				);
			},
		},
		{
			dataField: "seeCategories",
			text: "Categories",
			formatter: (cell, row) => {
				return (
					<div
						className="action-button"
						style={{ textAlign: "center" }}
					>
						<Link
							to={`${Routes.VendorCategories}/${row.id}`}
							style={{ fontSize: "larger" }}
						>
							<FontAwesomeIcon
								id="see"
								className="hoverEffect see-eye action-icon"
								icon={faEye}
								title="Categories"
								size="1x"
							/>
						</Link>
					</div>
				);
			},
		},
		{
			dataField: "seeContacts",
			text: "Contacts",
			formatter: (cell, row) => {
				return (
					<div style={{ textAlign: "center" }}>
						<Link
							to={`${Routes.VendorContact}/${row.id}`}
							style={{ fontSize: "larger" }}
						>
							<FontAwesomeIcon
								id="see"
								className="hoverEffect see-eye action-icon"
								icon={faEye}
								title="Contact"
								size="1x"
							/>
						</Link>
					</div>
				);
			},
		},
	];

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${ItemRequisitionAPI.GetItemRequisitionVendor}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
		} else {
			apiURL = `${ItemRequisitionAPI.GetItemRequisitionVendor}?PageNumber=${page}&PageSize=${numberOfItemsPerPage}`;
		}

		if (page) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setVendor(res.data.vendors);
				})
				.catch((err) => {
					if (err.response) {
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message} `,
						});
					}
				});
		}
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		let apiURL = "";
		apiURL = `${
			ItemRequisitionAPI.GetItemRequisitionVendor
		}?PageNumber=${1}&PageSize=${PageSize} `;
		axios
			.get(apiURL, {
				headers: { Authorization: `Bearer ${token} ` },
			})
			.then((res) => {
				setIsLoading(false);
				setNumberOfItemsPerPage(PageSize);
				setPagerData(JSON.parse(res.headers["x-pagination"]));
				setVendor(res.data.vendors);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message} `,
					});
				}
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				empDesignation = userDetails.designation;
				return userDetails.id.toString() === "40" ||
					userDetails.id.toString() === "33" ||
					userDetails.empRole.includes("3") ? (
					<Container fluid>
						<Header
							title="Vendors"
							headerBorder="true"
							navigateBack={() =>
								history.push(Routes.ItemRequisition)
							}
						/>

						<Row>
							<div className="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end py-2 searchColumn">
								<div>
									<Input
										id="DisabledAutoHideExample"
										className="form-control searchBar"
										type="text"
										placeholder="Search"
										onChange={(event) =>
											getVendors(event.target.value)
										}
									/>
									<Tooltip
										id="tooltip-top"
										placement="top"
										isOpen={tooltipOpen}
										autohide={false}
										target="DisabledAutoHideExample"
										contentStyle={{
											backgroundColor: "#118a8c",
										}}
										toggle={() =>
											setTooltipOpen(!tooltipOpen)
										}
									>
										Search by name, primary contact ,phone
										and email
									</Tooltip>
								</div>
								<Button
									className="primaryButton btn btn-secondary ml-2 vendor-btn"
									onClick={() => {
										history.push(Routes.CreateNewVendor);
									}}
								>
									Create
								</Button>
							</div>
						</Row>
						{pagerData ? (
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: vendor.length,
									page: pagerData?.CurrentPage,
									sizePerPage: pagerData?.PageSize,
									paginationSize: pagerData?.PageSize,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"id"}
											columns={getColumns}
											items={vendor}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											pagerData={pagerData}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
										/>
									);
								}}
							</PaginationProvider>
						) : (
							<Table
								inputValue={""}
								keyField={"phone"}
								columns={getColumns}
								items={vendor}
								tableStyle={tableStyle}
								defaultSorted={sortBy}
								showFeedback={false}
								tableLoader={isLoading}
								SearchBar={() => {
									return null;
								}}
							/>
						)}
					</Container>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
};

export default ItemRequisitionVendors;
